export const getFileExtension = (file: File) => file.name.split('.').pop()
